
export class User {
  id;
  name;
  role;
  tracks = new Map();
  constructor(data){
    this.id = data.id;
    this.name = data.name;
    this.role = data.role;
  }
}
